import { Box, Href, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'

const NotAuthenticated = () => {
  const { navigation } = useNavigation()
  const datevLaudsIntegrationDatoId = integrationCodes.datev_lauds_factorial

  return (
    <Box paddingTop="s24" paddingLeft="s24" paddingRight="s40">
      <Box
        background="champagne200"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
      >
        <Text.Header2>
          {i18n.t('payroll_integrations.incidences.datev_lauds.sync.unavailable.title')}
        </Text.Header2>
        <Box>
          {i18n.tView(
            'payroll_integrations.incidences.datev_lauds.sync.unavailable.message_with_link',
            {
              link: (
                <Href
                  href={navigation.discover.marketplace.item.settings.fullPath({
                    id: datevLaudsIntegrationDatoId,
                  })}
                  target="_blank"
                >
                  {i18n.t('payroll_integrations.incidences.datev_lauds.sync.unavailable.link')}
                </Href>
              ),
            }
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default NotAuthenticated
